import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(() => ({

  alert: {
    marginTop: '10px',
    width: '100%',
    '& .text': {
      color: '#3E8CC1 !important',
      fontWeight: 400,
    },
  },
  info: {
    marginTop: '10px',
    width: '100%',
    '& .text': {
      fontWeight: 400,
    },
  },
}), { name: 'purposeOfPayments' });

export default useStyles;
